import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { EMPTY, map, tap } from 'rxjs';
import { SYSTEM_CODE } from '../constants/app.constant';
import { BookingOrderModel, BookingStatus } from '../models/booking.model';
import { BookingService } from '@services/booking.service';
import { ToastService } from '@services/toast.service';
import { BaseResponseModel } from '@models/app.model';
import { TranslateService } from '@ngx-translate/core';

export const addItineraryResolver: ResolveFn<BaseResponseModel<BookingOrderModel> | null> = (
    route
) => {
    const bookingService = inject(BookingService);
    const toastService = inject(ToastService);
    const translateService = inject(TranslateService);
    const router = inject(Router);
    const code = route.queryParamMap.get('code');
    const allowChangeFlightCode = (code: string) => [SYSTEM_CODE.VJ, SYSTEM_CODE.VNA].includes(code as SYSTEM_CODE);
    const allowStatus = (status: number) =>
        [BookingStatus.IssueTicket, BookingStatus.Reservation].includes(status);

    if (!code) {
        router.navigate(['booking', 'manage']);
        return EMPTY;
    }

    return bookingService.getDetailBooking(code).pipe(
        tap((detail) => {
            if (!detail.Data.BookingCode) {
                toastService.showError(
                    translateService.instant('common.tabs.cancel'),
                    translateService.instant('pages.booking.toast.messages.bookingFailed')
                );
                router.navigate(['booking', 'manage']);
                return;
            }
            const isAllowChangeFlight =
                detail &&
                allowStatus(detail.Data.BookingStatusId) &&
                allowChangeFlightCode(detail.Data.SystemCode);

            if (!isAllowChangeFlight) {
                toastService.showError(
                    translateService.instant('common.tabs.cancel'),
                    translateService.instant('pages.booking.messages.canAddFlight')
                );
                router.navigate(['booking', 'manage']);
                return;
            }
        }),
        map((detail) => ({ ...detail, TransactionId: code }))
    );
};
